export default {
    HEADER: 'Kategorija proizvoda',
    PLACEHOLDER_NAME: 'Unesite naziv kategorije',
    LABEL_NAME: 'Naziv kategorije',
    LABEL_STATUS: 'Status',
    SAVE_BUTTON: 'Sačuvaj',
    CANCEL_BUTTON: 'Poništi',
};
